import React, { useEffect } from "react";
import './experience.scss';
import accenture from './../../image/accenture.svg';
import mon from './../../image/Logo.svg'
import glassfy from './../../image/Logo-1.svg'
import flutter from './../../image/flutter.jpeg'
import { Link } from "react-router-dom";

const Experience: React.FC = () => {


  function timeSinceOctober2025() {
    const start = new Date('2025-10-01');
    const now = new Date();
  
    let years = now.getFullYear() - start.getFullYear();
    let months = now.getMonth() - start.getMonth();
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    if (years > 0 && months > 0) {
      return `${years} year${years > 1 ? 's' : ''} and ${months} month${months > 1 ? 's' : ''}`;
    } else if (years > 0) {
      return `${years} year${years > 1 ? 's' : ''}`;
    } else {
      return `${months} month${months > 1 ? 's' : ''}`;
    }
  }
  

  return (
    <>
      <section className="experience container">
        <div className="wrapper">
          <h2>Experience</h2>
          <div className="experience-container">
            <div className="job">
              <div className="job-header">
                <div className="img-wrapper">
                  <img src={flutter} alt="" />
                </div>
                <div className="text-wrapper">
                  <h4>Interaction Design Specialist</h4>
                  <h5>Flutter Entertainment</h5>
                  <h6>Oct 2025 - Present • {timeSinceOctober2025()} • Milan, Italy</h6>
                </div>
              </div>
              <div className="job-description">
                <p>I’m a Product Designer at Flutter Entertainment, crafting betting, payments, and account experiences across iOS and Android for SISAL, SNAI, and PokerStars in multiple European and North African markets. I design intuitive journeys for high‑stakes, regulated products, from live betting flows to account management, always balancing user needs, compliance, and business goals.</p>
              </div>
              <div className="job-content">
                <p>Results and responsibilities:</p>
                <ul>
                  <li>Designed and optimized betting, payments, KYC, and withdrawal journeys serving 20M+ users across three brands and four markets.</li>
                  <li>Architected a unified cross‑brand design system to replace fragmented legacy patterns, enabling consistent experiences and faster delivery across mobile platforms.</li>
                  <li>Designed and shipped a live betting widget on iOS and Android to keep users engaged with in‑progress bets and reduce cart abandonment.</li>
                  <li>Collaborate daily with engineering on QA, bug triage, and implementation reviews, shipping design updates on 1–2 week sprint cycles.</li>
                  <li>Conduct user research and partner with Product and Data teams to identify friction in betting journeys, translating analytics and user testing into validated design improvements.</li>
                
                </ul>
              </div>
            </div>


          <div className="job">
              <div className="job-header">
                <div className="img-wrapper">
                  <img src={accenture} alt="" />
                </div>
                <div className="text-wrapper">
                  <h4>Interaction Designer</h4>
                  <h5>Accenture</h5>
                  <h6>Dec 2024 - Sep 2025 • 11 months • Milan, Italy</h6>
                </div>
              </div>
              <div className="job-description">
                <p>I'm an Interaction designer focused on websites, mobile apps, and the broader world of UX. I’ve designed intuitive interfaces, contributed to scalable design systems, and shaped user-centered experiences.</p>
              </div>
              <div className="job-content">
                <p>Results and responsibilities:</p>
                <ul>
                  <li>Designed and optimized user journeys for major clients in the insurance sector, focusing on website redesigns and quote funnel improvements.</li>
                  <li>Led the creation of wireframes and high-fidelity prototypes to support data-driven A/B testing initiatives.</li>
                  <li>Implemented on-site personalization strategies based on user behavior, resulting in a 150% uplift in form submissions on key product pages.</li>
                  <li>Maintained and contributed to the evolution of client-specific Design Systems to ensure consistency and scalability across digital touchpoints.</li>
                  <li>Collaborated closely with cross-functional teams including developers, PMs, and data analysts to align design decisions with business goals.</li>
                
                </ul>
              </div>
            </div>


            <div className="job">
              <div className="job-header">
                <div className="img-wrapper">
                  <img src={accenture} alt="" />
                </div>
                <div className="text-wrapper">
                  <h4>UX/UI Designer Intern</h4>
                  <h5>Accenture</h5>
                  <h6>Nov 2023 - Nov 2024 • 12 months • Milan, Italy</h6>
                </div>
              </div>
              <div className="job-description">
                <p>As a UI/UX Designer at Accenture, I specialized in creating user-friendly digital experiences for leading automotive brands. My role involved crafting intuitive interfaces that enhanced usability and drove engagement.</p>
              </div>
              <div className="job-content">
                <p>Results and responsibilities:</p>
                <ul>
                  <li>Research:</li>
                  
                    <ul>
                      <li>Conducted competitor research to inform design decisions.</li>
                      <li>Developed high-level touchpoint maps to understand user interactions.</li>
                      <li>Defined workshop components and facilitated client sessions for requirements gathering.</li>
                    </ul>

                    <li>UX:</li>
                  
                    <ul>
                      <li>Created Information Architecture (IA) for current and future state.</li>
                      <li>Designed wireframes for key pages.</li>
                      <li>Developep user-centric solutions through prototyping and iterative design processes.</li>
                    </ul>

                    <li>UI:</li>
                  
                    <ul>
                      <li>Established UI Kit & Design System for consistency across interfaces.</li>
                      <li>Crafted visually appealing interfaces by setting layout guidelines and creating UI components.</li>
                      <li>Implemented detailed designs to ensure a polished and intuitive user experience, facilitating developers in website development.</li>
                    </ul>

                </ul>
              </div>
            </div>


            <div className="job">
              <div className="job-header">
                <div className="img-wrapper">
                  <img src={mon} alt="" />
                </div>
                <div className="text-wrapper">
                  <h4>Web Designer</h4>
                  <h5>À MON CÔTÉ</h5>
                  <h6>Aug 2023 - Oct 2023 • 3 months • Remote</h6>
                </div>
              </div>
              <div className="job-description">
                <p>As the Web Designer for "À MON CÔTÉ," a media production startup, I was responsible for crafting their website, effectively showcasing their brand and services to their target audience.</p>
              </div>
            </div>
            <div className="job">
              <div className="job-header">
                <div className="img-wrapper">
                  <img src={glassfy} alt="" />
                </div>
                <div className="text-wrapper">
                  <h4>Flutter Developer</h4>
                  <h5>Glassfy</h5>
                  <h6>Aug 2022 - Sep 2022 • 2 months • Turin, Italy</h6>
                </div>
              </div>
              <div className="job-description">
                <p>Glassfy offers subscription infrastructure and real-time events for businesses. As a Flutter intern, I contributed to developing their open-source SDK and authored documentation for Flutter integration.</p>
              </div>
              <div className="job-content">
                <p>Results and responsibilities:</p>
                <ul>
                  <li>Development:</li>
                  
                    <ul>
                      <li>Created thorough documentation outlining the SDK integration process with Flutter, providing clear instructions and code examples for seamless implementation.</li>
                    </ul>

                    <li>UI:</li>
                  
                    <ul>
                      <li>Enhanced UI elements for documentation screenshots, ensuring visual appeal and clarity in demonstrating SDK integration processes within Flutter environments.</li>
                    </ul>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default Experience;
